// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logNetworkError = (error: any) =>
   console.error(error?.response?.data || error?.response || error?.toJSON() || error);
